// Corporate group portal roles (Group Owner / Group Admin). Both have the same access.
export const GROUP_OWNER_ROLE = '22';
export const GROUP_ADMIN_ROLE = '23';

export const isGroupPortalRole = roleId => roleId == GROUP_OWNER_ROLE || roleId == GROUP_ADMIN_ROLE;

export const GROUP_PORTAL_HOME = '/group/members';
